import EditSupervisors from "./EditSupervisors.jsx";
export default EditSupervisors;